import { withInstall } from '../../utils';
import Checkbox from './src/checkbox.vue';

export const ICheckbox = withInstall(Checkbox); // 增加类型

export default ICheckbox;
